import useConfirmation from '@rhg/hooks/use-confirmation';
import programMessages from '@rhg/lang/messages/program';
import { LockThinOutline } from '@rhg/libs/material/icons';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

export function useUnsponsoredDialog() {
    const { confirm } = useConfirmation();
    const { formatMessage } = useIntl();

    const showUnsponsoredDialog = useCallback(async () => {
        return await confirm({
            title: formatMessage(programMessages['program.content_locked']),
            body: formatMessage(programMessages['program.in_order_to_unlock']),
            confirmLabel: formatMessage(
                programMessages['program.validate_eligibility']
            ),
            trackDialog: 'RedirectRegistration',
            confirmTrackButton: 'RedirectRegistrationBeforeJoinProgram',
            icon: <LockThinOutline fontSize="large" color="inherit" />,
            iconColor: 'info',
            bodyTextAlign: 'center',
        });
    }, [confirm, formatMessage]);

    return { showUnsponsoredDialog };
}
